import Api from '@/api/Api';
import errorHandler from '@/utils/plugins/ErrorHandler';

const RESOURCE_NAME = '/api/api_applications';

export default {
    getApiApplications() {
        return Api().get(RESOURCE_NAME)
            .catch((err) => errorHandler(err, null));
    },
    getApiApplication(id) {
        return Api().get(`${RESOURCE_NAME}/${id}`)
            .catch((err) => errorHandler(err, null));
    },
    createApiApplication(data) {
        return Api().post(RESOURCE_NAME, data)
            .catch((err) => errorHandler(err, null));
    },
    updateApiApplication(id, data) {
        return Api().put(`${RESOURCE_NAME}/${id}`, data)
            .catch((err) => errorHandler(err, null));
    },
    rotateKey(id) {
        return Api().post(`${RESOURCE_NAME}/${id}/rotate_key`)
            .catch((err) => errorHandler(err, null));
    },
    revoke(id) {
        return Api().post(`${RESOURCE_NAME}/${id}/revoke`)
            .catch((err) => errorHandler(err, null));
    },
    getPermissions(id) {
        return Api().get(`${RESOURCE_NAME}/${id}/permissions`)
            .catch((err) => errorHandler(err, null));
    },
    updatePermissions(id, rows) {
        return Api().put(`${RESOURCE_NAME}/${id}/permissions`, rows)
            .catch((err) => errorHandler(err, null));
    },
}
